<template>
    <div class="hello">
      <el-dialog
        title="网站维护通知"
        :visible.sync="showMaintenancePopup"
        width="600px"
        :before-close="handleClose">
        <div class="maintenance-notice-content">
          <i class="el-icon-setting maintenance-icon"></i>
          <div class="title">网站维护通知</div>
          <div class="content">尊敬的用户，为了提供更好的服务，网站正在进行系统维护，<span style="color:#ff9900;font-weight:bold;">订票业务目前暂停</span>，预计很快恢复。<br>已订票的用户不受影响，您的订单将正常处理。给您带来的不便，敬请谅解！</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="showMaintenancePopup = false">我知道了</el-button>
        </span>
      </el-dialog>
    
    </div>
</template>

<script>
export default {
  name: 'SiteNotice', // Changed name for clarity
  data() {
    return {
      showMaintenancePopup: false
    }
  },
  methods : {
    show() {
      this.showMaintenancePopup = true;
    },
    handleClose() {
      this.showMaintenancePopup = false;
    }
  }
}
</script>

<style scoped >
  
.maintenance-notice-content {
  text-align: center;
}

.maintenance-icon {
  font-size: 40px;
  color: #ff9900;
}

.title {
  font-size: 20px; /* Adjusted from 40rpx */
  font-weight: 700;
  margin: 12px 0 6px 0; /* Adjusted from 24rpx/12rpx */
  color: #ff9900;
  letter-spacing: 1px; /* Adjusted from 2rpx */
}

.content {
  font-size: 15px; /* Adjusted from 30rpx */
  color: #444;
  margin-bottom: 18px; /* Adjusted from 36rpx */
  text-align: left;
  background: #fffbe6;
  border-radius: 6px; /* Adjusted from 12rpx */
  padding: 9px 10px; /* Adjusted from 18rpx/20rpx */
  box-shadow: 0 1px 4px rgba(255, 153, 0, 0.06); /* Adjusted from 2rpx/8rpx */
}

.dialog-footer {
  text-align: center;
  display: block; /* Ensure button is centered */
}

/* Removed .popup-btn-wrap as structure changed */

</style>


// WEBPACK FOOTER //
// src/components/site.vue